import { Result } from "antd";

export default function Error() {
  return <Result title='404' status='404' subTitle='Sorry, the page you visited does not exist.' />;
}
